import axios from 'axios';
import config from 'config';
import { createApi } from 'utils/api';

const dispatcherV2Api = axios.create({
  baseURL: config.userV2ApiBaseUrl,
  params: {
    apikey: config.dispatcherApiKey,
  },
});

const createDispatcherV2Api = createApi(dispatcherV2Api);
export const getDispatcherV2Data = createDispatcherV2Api('get');
export const patchDispatcherV2Data = createDispatcherV2Api('patch');
export const postDispatcherV2Data = createDispatcherV2Api('post');
export const putDispatcherV2Data = createDispatcherV2Api('put');